export const closestParentByTagName = (el, tagName) => {
    let element = el;
    const uppercaseTagName = tagName.toUpperCase();
    while (element && element.tagName !== uppercaseTagName) {
        element = element.parentElement;
    }
    return element;
};
